import React from 'react';
import { LoadingContent } from 'Shared/PageElements/LoadingContent';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';
import useLaunchDarkly from 'utils/Hooks/LaunchDarkly/useLaunchDarkly';

const LazyInvoicesPage = React.lazy(() => import('./Pages/InvoicesPage'));
const LegacyLazyInvoicesPage = React.lazy(() => import('./Pages/LegacyInvoicesPage'));

const TenantRoot = (): JSX.Element => {
    const isPaymentsFeatureEnabled: boolean | undefined = useLaunchDarkly(LaunchDarklyFlags.Payments);

    return (
        <React.Suspense fallback={<LoadingContent />}>
            {isPaymentsFeatureEnabled ? <LazyInvoicesPage /> : <LegacyLazyInvoicesPage />}
        </React.Suspense>
    );
};

export default TenantRoot;
